import LineChart from "components/pages/dashboard/chart/LineChart";
import React from "react";
import { patientAnalyticTooltipHandler } from "./patientAnalyticTooltip";

const PatientAnalyticChart = ({ chartData }) => {
  return (
    <LineChart
      options={{
        responsive: true,
        maintainAspectRatio: false,
        devicePixelRatio: 4,
        plugins: {
          legend: {
            labels: {
              boxWidth: 0,
              color: "#212121",
              font: {
                size: 12,
                weight: "700",
                style: "bold",
              },
            },
          },
          tooltip: {
            enabled: false,
            position: "nearest",
            external: patientAnalyticTooltipHandler,
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#333333",
              fontSize: 12,
              autoSkip: true,
              maxTicksLimit: 4,
              maxRotation: 0,
              minRotation: 0,
            },
          },
          y: {
            ticks: {
              color: "#333333",
              fontSize: 12,
            },
            beginAtZero: true,
          },
        },
      }}
      data={{
        labels: chartData?.labels,
        datasets: [
          {
            label: chartData.title,
            data: chartData.data,
            duration: chartData.duration,
            fill: false,
            borderColor: "#94BA33",
            backgroundColor: "#94BA33",
            borderWidth: 1,
          },
        ],
      }}
    />
  );
};

export default PatientAnalyticChart;
